import { LoadableAfterPaint } from '@confluence/loadable';

export const BlogsToggledOffByPTLChangeboarding = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BlogsToggledOffByPTLChangeboarding" */ '../src/BlogsToggledOffByPTLChangeboarding'
			)
		).BlogsToggledOffByPTLChangeboarding,
});
